module.exports = __webpack_public_path__ + "img/certificate-EC-Pre.e6d8fde6.jpg";